import api from '@/utils/api';

/**
 * Update quote
 * @param {string} id quote id
 * @param {object} quoteData - The quote data
 * @returns {Promise}
 */
const closeQuoteApi = (id, quoteData) =>
  api.patch(`/quote/${id}/close`, quoteData);

export default closeQuoteApi;
